var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.386,
    height: 109.557,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2888.62 -1283.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2965.578 1353.634a43.2 43.2 0 10-6.792 6.786l.152.152 5.749 5.749 6.816-6.816-5.749-5.75z",
    fill: "#b3cde3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.425,
    cy: 37.425,
    r: 37.425,
    transform: "translate(2894.044 1289.196)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2964.52 1366.321l-.227.227a2.892 2.892 0 000 4.089l4.012 4.011 4.544 4.544 12.946 12.947a2.892 2.892 0 004.09 0l7.27-7.27a2.891 2.891 0 000-4.089l-6.408-6.409-6.539-6.538-4.544-4.544-4.01-4.01a2.891 2.891 0 00-4.09 0l-.227.228zm-1.038-10.127",
    fill: "#6d8dc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2921.14 1324.764l-8.092 5.474h-7.057M2934.772 1337.731l-2.856 12.375h-11.661",
    stroke: "#6d8dc1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.932,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.499,
    cy: 2.499,
    r: 2.499,
    transform: "translate(2915.064 1347.672)",
    fill: "#369528"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.499,
    cy: 2.499,
    r: 2.499,
    transform: "translate(2901.057 1327.679)",
    fill: "#db0001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2956.484 1325.095a18.368 18.368 0 00.911-4.377l-3.019-1.462c0-.49-.014-.983-.058-1.478-.012-.171-.035-.339-.055-.509l2.84-1.8a18.428 18.428 0 00-1.389-4.246l-3.354.243a15.266 15.266 0 00-1.091-1.668l1.562-2.969a18.837 18.837 0 00-3.331-2.98l-2.781 1.885a15.738 15.738 0 00-1.776-.9l-.132-3.351a18.531 18.531 0 00-4.376-.915l-1.463 3.022a15.27 15.27 0 00-1.476.057c-.173.015-.342.037-.511.057l-1.791-2.843a18.646 18.646 0 00-4.25 1.391l.245 3.354a15.038 15.038 0 00-1.667 1.091l-2.971-1.562a18.577 18.577 0 00-2.979 3.333l1.887 2.78a15.256 15.256 0 00-.9 1.774l-3.353.132a18.416 18.416 0 00-.911 4.378l3.02 1.462c0 .489.013.982.056 1.477.015.172.036.339.059.51l-2.843 1.793a18.574 18.574 0 001.391 4.246l3.353-.243a15.34 15.34 0 001.09 1.667l-1.562 2.969a18.657 18.657 0 003.332 2.981l2.78-1.885a15.219 15.219 0 001.776.9l.132 3.352a18.447 18.447 0 004.374.912l1.466-3.02c.488 0 .982-.014 1.478-.057.17-.013.339-.037.506-.058l1.793 2.845a18.672 18.672 0 004.25-1.39l-.242-3.355a16.371 16.371 0 001.666-1.091l2.97 1.562a18.818 18.818 0 002.978-3.332l-1.883-2.78a16.663 16.663 0 00.9-1.777zm-17.641 3.654a9.624 9.624 0 119.624-9.624 9.624 9.624 0 01-9.624 9.624z",
    fill: "#0c1e6c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.857,
    fill: "none",
    d: "M2986.824 1384.785l7.042-7.043M2982.645 1388.99l11.221-11.248"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout02);
export default __webpack_public_path__ + "static/media/about-02.c0e184b1.svg";
export { ForwardRef as ReactComponent };